var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{ref:"dialog",staticClass:"popupBox",style:(("position:" + _vm.position)),on:{"touchmove":function($event){_vm.cantouchmove ? '' : _vm.touchmove}}},[_c('div',{staticClass:"mask",style:(("background-color:rgba(0,0,0," + _vm.opacity + ");position:" + _vm.position)),on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.hideOnBlur && _vm.closeTips()}}}),_vm._v(" "),_c('div',{staticClass:"popupContent",class:{ dialogout: _vm.isfadeout },style:({
      overflow: _vm.overflow,
      width: _vm.width ? _vm.width + '%' : '80%',
      top: _vm.top ? parseFloat(_vm.top / 75) + 'rem' : '0',
      bottom: _vm.top == '0' ? '0' : 'auto',
      background: _vm.backgroundColor,
      'border-radius': _vm.borderRadius,
    })},[_vm._t("content")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680bb2e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/starcharge/components/Popup/x-dialog.vue
// module id = lFN0
// module chunks = 81